export enum JOB_APPLICATION_LIST_COLUMNS_VALUES {
  COMPANY_NAME = "companyName",
  OFFER_TITLE = "offerTitle",
  APPLICANT_NAME = "applicantName",
  STATUS = "approvalStatus",
  UPDATED_AT = "updatedAt",
  ACTIONS = "actions"
}

export const JOB_APPLICATION_LIST_COLUMNS = [
  JOB_APPLICATION_LIST_COLUMNS_VALUES.COMPANY_NAME,
  JOB_APPLICATION_LIST_COLUMNS_VALUES.OFFER_TITLE,
  JOB_APPLICATION_LIST_COLUMNS_VALUES.APPLICANT_NAME,
  JOB_APPLICATION_LIST_COLUMNS_VALUES.STATUS,
  JOB_APPLICATION_LIST_COLUMNS_VALUES.UPDATED_AT,
  JOB_APPLICATION_LIST_COLUMNS_VALUES.ACTIONS
];
